
import { Link } from "react-router-dom";
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busonrentinpune() {



    const cardData = {
    keyword: "Bus on Rent in Pune",
    heading: "Affordable Bus on Rent in Pune for Every Journey",
    headingDescription:
"Looking for a Bus on Rent in Pune? Amruta Travels provides 25, 32, 35, 45 and 50-seater buses for weddings, corporate travel, school trips, picnics, airport transfers, local sightseeing and outstation tours. Our buses are clean, professionally driven and available at competitive prices across Pune.",


        top: "How to Book a Bus on Rent in Pune",

"topPlaces":[
{
"title":"Share Your Travel Requirement",
"description":"Tell us your travel date, pickup location, destination, number of passengers, travel duration, and purpose such as wedding, corporate event, school trip, picnic, airport transfer, or outstation journey."
},
{
"title":"Choose the Right Bus",
"description":"Select from our fleet of 25, 32, 35, 45, and 50-seater AC and Non-AC buses, luxury coaches, and group travel vehicles based on your requirements."
},
{
"title":"Receive a Transparent Quotation",
"description":"Get a detailed quotation with vehicle details, pricing, driver charges, travel plan, and payment terms without hidden costs."
},
{
"title":"Confirm Your Booking",
"description":"Reserve your preferred bus by confirming your travel schedule. Early booking helps secure your preferred vehicle during weekends and peak seasons."
},
{
"title":"Professional Driver Allocation",
"description":"Experienced and verified drivers are assigned to every booking to ensure safe, punctual, and comfortable travel throughout your journey."
},
{
"title":"Timely Vehicle Reporting",
"description":"Your bus reports to the pickup location on time, allowing your group to begin the journey without unnecessary delays."
},
{
"title":"Comfortable Group Travel",
"description":"Enjoy clean, well-maintained buses with comfortable seating, spacious interiors, and reliable service for every type of group travel."
},
{
"title":"Support Throughout Your Journey",
"description":"Our support team remains available before, during, and after your trip to assist with route changes, additional requirements, or travel coordination."
},
{
"title":"Safe Return Journey",
"description":"After your event or trip, we ensure safe and timely drop-offs at your preferred destination with the same professional service."
},
{
"title":"Trusted Bus Rental in Pune",
"description":"Thousands of customers choose Amruta Travels for dependable Bus Rental in Pune because of our quality fleet, transparent pricing, and customer-first approach."
}
],


 "services":[
{
"name":"Bus Rental in Pune",
"description":"Amruta Travels provides reliable Bus Rental in Pune for local travel, outstation trips, corporate events, weddings, school excursions, airport transfers, religious tours, sightseeing, and family functions with professional drivers and well-maintained buses."
},
{
"name":"Luxury Bus Rental",
"description":"Hire luxury buses with premium seating, air conditioning, spacious interiors, and modern amenities for VIP guests, weddings, corporate events, and comfortable group travel."
},
{
"name":"AC & Non AC Bus Rental",
"description":"Choose from AC and Non AC buses according to your budget and travel requirements. Our fleet is suitable for both local and long-distance journeys."
},
{
"name":"Corporate Bus Rental",
"description":"We provide buses for employee transportation, office outings, conferences, corporate events, client visits, and business travel across Pune and nearby cities."
},
{
"name":"Wedding Bus Rental",
"description":"Comfortable guest transportation for weddings, receptions, Haldi, Mehendi, Sangeet, destination weddings, and family celebrations with customized travel schedules."
},
{
"name":"School & College Bus Rental",
"description":"Safe and dependable buses for school trips, educational tours, industrial visits, college excursions, and student transportation with experienced drivers."
},
{
"name":"Picnic & Group Tour Bus Rental",
"description":"Book buses for family picnics, group tours, sightseeing, holiday packages, religious tours, and weekend trips with flexible pickup and drop locations."
},
{
"name":"Outstation Bus Rental",
"description":"Travel comfortably from Pune to Lonavala, Mahabaleshwar, Shirdi, Nashik, Goa, Alibaug, Mumbai, and other destinations with our outstation bus rental services."
},
{
"name":"Airport Transfer Bus Rental",
"description":"Reliable airport pickup and drop services for corporate groups, tourists, wedding guests, and families travelling to or from Pune Airport."
},
{
"name":"25 to 50 Seater Bus Rental",
"description":"Choose from our fleet of 25, 32, 35, 45, and 50-seater buses for every group size, ensuring comfortable and affordable transportation."
},
{
"name":"Tempo Traveller & Group Travel",
"description":"Along with buses, we also provide Tempo Travellers and group travel vehicles for smaller groups requiring flexible transportation within Pune and outstation."
},
{
"name":"Customized Bus Rental Solutions",
"description":"Every trip is different. We create customized transportation plans based on passenger count, destination, event type, duration, and budget to provide the most suitable vehicle."
}
],

  "tableData":[
["Bus on Rent in Pune","Bus Hire in Pune"]
["Daily Bus Hire","Local Bus Rental"]
["One Day Bus Hire","Weekend Bus Hire"]
["Bus Hire for Weddings","Corporate Bus Hire"],
["Bus on Rent in Pune","Luxury Bus Rental in Pune"],
["AC Bus Rental in Pune","Non AC Bus Rental in Pune"],
["Corporate Bus Rental","Employee Transportation"],
["Wedding Bus Rental","Marriage Bus Booking"],
["School Bus Rental","College Trip Bus Rental"],
["Picnic Bus Rental","Group Tour Bus Rental"],
["Outstation Bus Rental","Airport Bus Rental"],
["25 Seater Bus Rental","32 Seater Bus Rental"],
["35 Seater Bus Rental","45 Seater Bus Rental"],
["50 Seater Bus Rental","Tempo Traveller on Rent"],
["Bus Rental Service in Pune","Affordable Bus Rental Pune"]
],





"whychoose":[
{
"WhyChooseheading":"Largest Bus Rental Fleet in Pune",
"WhyChoosedescription":"Amruta Travels offers a wide range of well-maintained AC, Non-AC, luxury, and premium buses with seating capacities from 25 to 50 passengers. Whether you need a single vehicle or multiple buses, we have the right fleet for every requirement."
},
{
"WhyChooseheading":"Bus Rental for Every Travel Requirement",
"WhyChoosedescription":"From weddings, corporate events, employee transportation, school trips, airport transfers, family outings, religious tours, sightseeing, and outstation travel, we provide complete transportation solutions under one roof."
},
{
"WhyChooseheading":"Professional Drivers & Safe Travel",
"WhyChoosedescription":"Every trip is handled by experienced, licensed, and professional drivers who prioritize passenger safety, punctuality, and courteous service throughout your journey."
},
{
"WhyChooseheading":"Transparent Pricing with No Hidden Charges",
"WhyChoosedescription":"We provide detailed quotations with clear pricing, helping customers understand exactly what they are paying for without unexpected charges."
},
{
"WhyChooseheading":"Flexible Pickup, Drop & Travel Planning",
"WhyChoosedescription":"Whether you require multiple pickup points, hotel transfers, airport pickups, or customized travel routes, our team creates a transportation plan that fits your schedule."
},
{
"WhyChooseheading":"Clean, Comfortable & Well-Maintained Buses",
"WhyChoosedescription":"Every bus is regularly serviced, cleaned, and inspected before departure to ensure a comfortable travel experience for families, corporate teams, students, and tourists."
},
{
"WhyChooseheading":"Serving Pune & Popular Outstation Destinations",
"WhyChoosedescription":"We provide Bus Rental in Pune along with transportation to Lonavala, Mahabaleshwar, Shirdi, Nashik, Mumbai, Goa, Alibaug, and many other destinations across Maharashtra and India."
},
{
"WhyChooseheading":"Trusted Bus Rental Company in Pune",
"WhyChoosedescription":"Thousands of customers choose Amruta Travels because of our reliable fleet, responsive support team, flexible rental options, professional service, and commitment to delivering a smooth group travel experience."
}
]















    }

const faqData = [
{
question: "How can I book a bus rental in Pune with Amruta Travels?",
answer: "Booking a bus with Amruta Travels is simple. Share your travel date, pickup location, destination, passenger count, and travel requirements. Our team will recommend the most suitable bus and provide a transparent quotation."
},
{
question: "What types of buses are available for rent in Pune?",
answer: "We provide 25, 32, 35, 45, and 50-seater AC and Non-AC buses along with luxury coaches and Tempo Travellers for weddings, corporate travel, school trips, airport transfers, sightseeing, and outstation journeys."
},
{
question: "Do you provide buses for corporate events and employee transportation?",
answer: "Yes. Amruta Travels offers buses for corporate meetings, conferences, employee transportation, office outings, team events, exhibitions, and business travel across Pune."
},
{
question: "Can I rent a bus for weddings and family functions?",
answer: "Absolutely. We provide buses for weddings, receptions, Haldi, Mehendi, Sangeet, family gatherings, and guest transportation with customized pickup and drop schedules."
},
{
question: "Do you provide buses for school and college trips?",
answer: "Yes. Our buses are available for school excursions, educational tours, industrial visits, college trips, and student transportation with experienced drivers."
},
{
question: "Can I hire a bus for outstation travel from Pune?",
answer: "Yes. We provide outstation bus rental services from Pune to destinations including Lonavala, Mahabaleshwar, Shirdi, Nashik, Mumbai, Goa, Alibaug, and many other locations."
},
{
question: "How much does Bus Rental in Pune cost?",
answer: "Bus rental pricing depends on factors such as travel distance, duration, bus type, seating capacity, and itinerary. Contact Amruta Travels for a customized quotation based on your travel plan."
},
{
question: "Why choose Amruta Travels for Bus Rental in Pune?",
answer: "Customers choose Amruta Travels because of our well-maintained fleet, experienced drivers, transparent pricing, punctual service, flexible travel planning, and dedicated customer support."
},
{
question: "Do you provide airport pickup and drop bus services?",
answer: "Yes. We provide reliable airport pickup and drop services for corporate groups, tourists, wedding guests, families, and other group travel requirements."
},
{
question: "Which areas of Pune do you serve?",
answer: "We provide Bus Rental services across Pune including Baner, Hinjawadi, Kharadi, Wakad, Pimpri-Chinchwad, Hadapsar, Kothrud, Magarpatta, Viman Nagar, Camp, and surrounding areas."
}
];

const testimonials = [
{
name: "Rahul Sharma",
designation: "Corporate HR Manager",
text: "We hired multiple buses from Amruta Travels for our corporate event in Pune. The buses arrived on time, were clean, and the entire transportation was managed professionally. Highly recommended for corporate bus rental."
},
{
name: "Priya Deshmukh",
designation: "Wedding Customer",
text: "Amruta Travels handled transportation for our wedding guests perfectly. The buses were comfortable, punctual, and the drivers were very cooperative throughout the event."
},
{
name: "Amit Kulkarni",
designation: "School Coordinator",
text: "We booked buses for our school's educational tour. The vehicles were well-maintained and the drivers ensured a safe journey. Excellent service for school trips."
},
{
name: "Sneha Patil",
designation: "Family Trip Organizer",
text: "We rented a bus for our family trip from Pune to Mahabaleshwar. The booking process was easy, pricing was transparent, and the journey was extremely comfortable."
},
{
name: "Vikas Mehta",
designation: "Corporate Client",
text: "Professional service, experienced drivers, and excellent customer support. Amruta Travels is our preferred partner whenever we need Bus Rental in Pune."
}
];







































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const images = [
  {
    src: "/images/gallery/24.jpg",
    alt: "Bus Hire For Wedding in Pune",
    link: "/Bus-Hire-For-Wedding-in-Pune",
  },
  {
   src: "/images/gallery/24.jpg",
   alt: "Bus Rental in Pune",
   link: "/bus-rental-in-pune"
},
  {
    src: "/images/gallery/28.jpg",
    alt: "Buses For Corporate Events",
    link: "/Buses-For-Corporate-Events",
  },
  {
    src: "/images/gallery/31.jpg",
    alt: "Bus Rental in Pune",
    link: "/bus-rental-in-pune",
},
  {
    src: "/images/gallery/2.jpg",
    alt: "25 Seater Tempo Traveller on Rent in Pune",
    link: "/25-Seater-Tempo-Traveller-on-Rent-in-Pune",
  },
  {
    src: "/images/gallery/3.jpg",
    alt: "32 Seater Bus Rent in Pune",
    link: "/32-Seater-Bus-Rent-in-Pune",
  },
  {
    src: "/images/gallery/24.jpg",
    alt: "35 Seater Bus on Rent in Pune",
    link: "/35-Seater-Bus-on-Rent-in-Pune",
  },
  {
    src: "/images/gallery/27.jpg",
    alt: "45 Seater Bus on Rent in Pune",
    link: "/45-Seater-Bus-on-Rent-in-Pune",
  },
  {
    src: "/images/gallery/29.jpg",
    alt: "50 Seater Bus On Rent in Pune",
    link: "/50-Seater-Bus-On-Rent-in-Pune",
  },
  {
    src: "/images/gallery/30.jpg",
    alt: "Bus Rental for Tour Packages",
    link: "/Bus-Rental-for-Tour-Packages",
  },
  {
    src: "/images/gallery/31.jpg",
    alt: "Luxury Bus Rental in Pune",
    link: "/Luxury-Bus-Rental-in-Pune",
  },
];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus on Rent in Pune",
"image": "https://bushireinpune.com/images/keyword/68.jpg",
"description":
"Amruta Travels provides Bus on Rent in Pune for weddings, corporate events, employee transportation, school trips, airport transfers, sightseeing, family outings and outstation travel.",
"brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4780"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",  // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-on-rent-in-pune"
  }
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Amruta Travels",
  "image": "https://bushireinpune.com/images/logo.jpg",
  "@id": "https://bushireinpune.com/",
  "url": "https://bushireinpune.com/",
  "telephone": "+91-7353109555",
  "email": "booking@bushireinpune.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office No.-2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411041",
    "addressCountry": "IN"
  },
  "areaServed": "Pune",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59"
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://bushireinpune.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Bus on Rent in Pune",
      "item": "https://bushireinpune.com/bus-on-rent-in-pune"
    }
  ]
};

const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Bus on Rent in Pune",
  "name": "Bus on Rent in Pune",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Amruta Travels",
    "url": "https://bushireinpune.com/"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "description": "Bus on Rent in Pune for corporate events, weddings, employee transportation, school trips, airport transfers and outstation travel.",
  "url": "https://bushireinpune.com/bus-on-rent-in-pune"
};



    return (
        <div>


<Helmet>
    <title>
Bus on Rent in Pune | Daily Bus Hire, Local & Outstation Bus Booking | Amruta Travels
</title>
  <meta
  name="description"
  content="Looking for Bus on Rent in Pune? Book 25, 32, 35, 45 and 50 Seater buses for local travel, corporate events, weddings, school trips, airport transfers and outstation journeys with Amruta Travels."
/>
  
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

  <script type="application/ld+json">
    {JSON.stringify(localBusinessSchema)}
</script>

<script type="application/ld+json">
    {JSON.stringify(breadcrumbSchema)}
</script>

<script type="application/ld+json">
    {JSON.stringify(serviceSchema)}
</script>

</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h1 className="white text-center">
    {cardData.keyword}
</h1>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/64.jpg' alt="Bus on Rent in Pune by Amruta Travels" />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonials}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {images.map((e) => {
                                return (
                                    <div className="box1">
                                        <Link
    to={e.link}
    title={e.alt}
    className="d-flex justify-content-around align-items-center"
>
                                            <div className="b1">
                                                <img
    src={e.src}
    alt={e.alt}
    loading="lazy"
/>
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <span className='px-3'>{e.alt}</span>
                                            </div>
                                        </Link>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busonrentinpune;